import { benefits } from '@/mocks/categories';

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
            Korzyści
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Dlaczego warto korzystać z Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Odkryj, jak nasze arkusze i listy produktów mogą zmienić Twoje doświadczenia zakupowe.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-accent-200 transition-all"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-xl text-accent-600`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}